function fixCardModel(oCardModel) {
	oCardModel.Address.Default = new Boolean(oCardModel.Address.Default);
	oCardModel.Address.Active = new Boolean(oCardModel.Address.Active);
	oCardModel.Address.LinkedAddress = new Boolean(oCardModel.Address.LinkedAddress);
	
	oCardModel.IsDefault = new Boolean(oCardModel.IsDefault);
	oCardModel.IsSaved = new Boolean(oCardModel.IsSaved);
	oCardModel.IsAuthorized = new Boolean(oCardModel.IsAuthorized);
}
var AuthenticationLayer = function () {
    "use strict";
    const antiForgeryToken = { "__RequestVerificationToken": document.querySelectorAll('input[name=__RequestVerificationToken]')[0] ? document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value : "" },
    verificationToken = document.querySelectorAll('input[name=__RequestVerificationToken]')[0] ? document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value : "";

    var authOrderId,
        authOrderIdSource,
        authSessionId,
        authTransactionId,
        authMerchantId,
        authAmount,
        emailAddress,
        creditCard,
        errorCallback,
        continuationCallback,
        authenticatedCards,
        callbackParams,
        authModal,
        
        init = function (orderId, orderIdSource, sessionId, transactionId, merchantId, errorFunction) {
            initAuthDialog();
            authOrderId = orderId;
            authOrderIdSource = orderIdSource;
            authSessionId = sessionId;
            authTransactionId = transactionId;
            authMerchantId = merchantId;
            errorCallback = errorFunction;
            authenticatedCards = [];

            initEventListener();
            configureAuth();
        },
        
	 hideCloseBtn = () => {
		authModal.HideCloseBtn();
	 },
	 
        initAuthDialog = () => {
        	authModal = new Dialog4i();
		authModal.Init({
			triggerElements: [],
			dialogClass: "authenticationDialog fullDialog", 
			title: "Reauthentication", 
			content: '<div id="issuerDiv"></div><div id="authiframe"></div>',
			onOpen: hideCloseBtn
		});
    	},

        initEventListener = function () {
        window.appInsights && appInsights.trackTrace({ message:  "initEventListener" });
            const eventorigin = document.getElementById("EventOrigin").value.replace(/\/$/, "");
            window.addEventListener("message", (event) => {
            	   if (event.data == "AuthenticationComplete" && event.origin.replace(/\/$/, "") !== eventorigin) {
                	window.appInsights && appInsights.trackTrace({ message:  "AuthenticationComplete message received for order: " + authOrderId + " origin mismatch: " + event.origin + " " + eventorigin});
                }
                if (event.origin.replace(/\/$/, "") !== eventorigin)
                    return;
                if (event.data == "AuthenticationComplete") {
                	window.appInsights && appInsights.trackTrace({ message:  "AuthenticationComplete message received for order: " + authOrderId});
                    authModal.Close();
                    authenticatedCards.push({ CardID: creditCard.CardID, CardNumber: creditCard.CardNumber, TransactionID: authTransactionId });
                    continuationCallback.apply(this, callbackParams);
                }
            }, false);
        },

        createSession = function (card) {
		fixCardModel(card);
		fetch('/authentication/CreateAuthenticationSession', { 
			method: 'POST', 
			body: JSON.stringify({ orderId: authOrderId, orderIdSource: authOrderIdSource }), 
			headers: { 
				'Content-Type': 'application/json', 
				'X-Requested-With': 'fetch', 
				'RequestVerificationToken': verificationToken, 
				'__RequestVerificationToken': verificationToken 
			}
		}).then(function(response){
			return  (response.ok) ? response.json() : []; // response.json() returns a promise
		}).then(function(response){
			authSessionId = response.SessionId;
	                authTransactionId = response.TransactionId;
	                configureAuth();
	                updateSession(card);
		}).catch(function(error){
			errorCallback("createSession: " + JSON.stringify(error));
		});
        },

        updateSession = function (card) {
        	fixCardModel(card);
        	let data = { 
        		payment: card, 
        		orderId: authOrderId, 
        		orderIdSource: authOrderIdSource, 
        		sessionId: authSessionId, 
        		amount: authAmount, 
        		email: emailAddress 
        	};     			
		fetch('/authentication/UpdateAuthenticationSession', { 
			method: 'POST', 
			body: JSON.stringify(data), 
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With': 'fetch',
				'RequestVerificationToken': verificationToken,
				'__RequestVerificationToken': verificationToken 
			}
		}).then(function(response){
			return  (response.ok) ? response.json() : []; // response.json() returns a promise
		}).then(function(response){
			if (response.Success) {
                	if (authSessionId != response.SessionId) {
                        authSessionId = response.SessionId; //session may have timed out...update will get a new one if so
                        configureAuth();
                    }
                    initiateAuthentication();
                }
                else {
                	errorCallback("updateSession: response.Success is false");
                }
		}).catch(function(error){
			errorCallback("updateSession: " + JSON.stringify(error));
		});
        },

        configureAuth = function () {
        	let response;
            try {
                if (!ThreeDS) {
                    errorCallback("configureAuth: missing ThreeDS js");
                }

                response = ThreeDS.configure({
                    merchantId: authMerchantId,
                    sessionId: authSessionId,
                    containerId: 'authiframe',
                    callback: function () {
                        if (!ThreeDS.isConfigured()) {
                            errorCallback("configureAuth: failed isConfigured()");
                        }
                    },
                    configuration: {
                        userLanguage: "en-US",
                        wsVersion: 62
                    }

                });
            } catch (error) {
                errorCallback("configureAuth: " + JSON.stringify(response));
            }
        },

        initiateAuthentication = function () {
            try {
                ThreeDS.initiateAuthentication(authOrderId, authTransactionId, function (data) {
                    if ((data.restApiResponse.result == 'SUCCESS' || data.restApiResponse.result == 'PENDING')
                        && (data.restApiResponse.transaction.authenticationStatus == 'AUTHENTICATION_AVAILABLE' || data.restApiResponse.transaction.authenticationStatus == 'AUTHENTICATION_PENDING')
                        && data.restApiResponse.response.gatewayRecommendation == 'PROCEED') {

			    setTimeout(() => { authenticatePayer(0); }, 2000);
                    }
                    else {
                        errorCallback("initiateAuthentication " + JSON.stringify(data));
                    }

                });
            } catch (error) {
                errorCallback("initiateAuthentication " + JSON.stringify(error));
            }
        },

        authenticatePayer = function (retryCount) {

            try {
                var optionalParams = {
                    fullScreenRedirect: false
                };
                ThreeDS.authenticatePayer(authOrderId, authTransactionId, function (data) {

                    if (!data.error) {
                        authModal.Open();

                        const threeDS = document.getElementById("issuerDiv");
                        threeDS.innerHTML = data.restApiResponse.authentication.redirectHtml;

                        eval(document.getElementById('authenticate-payer-script').text);
                        authSessionId = 0;
                    }
                    else {
                        if (data.error.cause && data.error.cause == "SERVER_BUSY" && retryCount < 5) {
                            ++retryCount;
                            setTimeout(() => { authenticatePayer(retryCount); }, 1000);																			   
                        } else {
                            errorCallback("authenticatePayer fail " + JSON.stringify(data.error));
                        }
                    }

                }, optionalParams);
            } catch (error) {
                errorCallback("authenticatePayer " + JSON.stringify(error));
            }
        },

        /*
        deleteSession = function () {
            var deletesession = ajax({
                url: "/authentication/DeleteAuthenticationSession",
                method: "POST",
                data: { orderId: authOrderId },
                headers: antiForgeryToken
            }).then(function (response, xhr) {

            }).catch(function (response, xhr) {

            });
        },
        */
        getAuthenticationResponse = function (card) {
            var found = authenticatedCards.find(x => x.CardID == card.CardID || x.CardNumber == card.CardNumber);
            if (found) {
                return {
                    TransactionId: found.TransactionID,
                    SessionId: String(authSessionId),
                    OrderId: authOrderId
                };
            }
            return { TransactionId: 0 };
        },

        updateCardId = function (cardNumber, cardID) {
            var found = authenticatedCards.find(x => x.CardNumber === cardNumber);
            if (found) {
                found.CardID = cardID;
            }
        },

        removeCard = function (creditCard) {
            var index = authenticatedCards.map(function (x) { return x.CardNumber; }).indexOf(creditCard.CardNumber);
            if (index < 0) {
                index = authenticatedCards.map(function (x) { return x.CardID; }).indexOf(creditCard.CardID);
            }
            if (index > -1) {
                authenticatedCards.splice(index, 1);
            }
        },

        authenticate = function (card, amount, nextStepCallback, params, email) {

            creditCard = card;
            authAmount = amount;
            continuationCallback = nextStepCallback;
            callbackParams = params;
            emailAddress = email;
		
            if (authSessionId == 0) {
                createSession(card);
            }
            else {
                updateSession(card);
            }
        };

    return {
        Init: init,
        Authenticate: authenticate,
        GetAuthenticationResponse: getAuthenticationResponse,
        UpdateCardId: updateCardId,
        RemoveCard: removeCard
    };

};

var authenticationLayer4i = new AuthenticationLayer();